import { all, delay, put, select, takeLatest } from 'redux-saga/effects';
import {
  maybeDisplayTypingIndicator,
  setTypingText,
  stopTyping,
  stopTypingLater,
} from '../../actions/room';
import { getActiveRoomId } from '../../selectors/room';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { PapiUser } from '@wix/da-papi-types';
import i18next from 'i18next';

/**
 * See if we need to display typing indication
 */
function* handleTypingIndicator(action: ReturnType<typeof maybeDisplayTypingIndicator>) {
  yield delay(500);

  const state = action.payload.state.newState;
  const currentRoom = yield select(getActiveRoomId);
  const currentUser: PapiUser = yield select(getCurrentUser);

  if (!state[currentRoom] || state[currentRoom].length === 0) {
    yield put(stopTypingLater(1000));
    return;
  }

  const now = Date.now();
  const typingUsers: string[] = [];

  state[currentRoom].forEach(entry => {
    if (entry.typing && now - entry.typing <= 4000) {
      // Don't include the current user in the typing indicator
      if (entry.user_id !== currentUser.useridUuid && entry.username) {
        typingUsers.push(entry.username);
      }
    }
  });

  if (typingUsers.length === 0) {
    yield put(stopTypingLater(1000));
    return;
  }

  let typingText = '';

  if (typingUsers.length === 1) {
    typingText = i18next.t('damz:damz.room.typing.indicator.one', {
      username: typingUsers[0],
    });
  } else if (typingUsers.length === 2) {
    typingText = i18next.t('damz:damz.room.typing.indicator.two', {
      username: typingUsers[0],
      username2: typingUsers[1],
    });
  } else {
    typingText = i18next.t('damz:damz.room.typing.indicator.many');
  }

  yield put(setTypingText(typingText));
  yield put(stopTypingLater(5000));
}

function* handleStopTypingDelayed(action: ReturnType<typeof stopTypingLater>) {
  yield delay(action.payload.delay);
  yield put(stopTyping());
}

/**
 * Typing indicators saga - handles typing indicator display and management
 */
export function* roomTypingSaga() {
  yield all([
    takeLatest(maybeDisplayTypingIndicator, handleTypingIndicator),
    takeLatest(stopTypingLater, handleStopTypingDelayed),
  ]);
}
